import EmblaCarousel from 'embla-carousel'
import { addDotBtnsAndClickHandlers } from './js/embla-carousel-dots.js'
import { addPrevNextBtnsClickHandlers } from './js/embla-carousel-arrows.js'

// ========================= Header menu mobile =========================
document.addEventListener("DOMContentLoaded", function () {
   /* START ============= MENU MOBILE */
   const smdev_header_nav = document.querySelector('.smdev_header nav');
   const smdev_header_btn_burger = document.querySelector(".smdev_header_btn_burger");
   const smdev_header_btn_burger_div = document.querySelector(".smdev_header_btn_burger div");

   // Toggle menu visibility
   function smdev_handle_menu_mobile(event) {
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();

      const isMenuOpen = smdev_header_nav.classList.toggle("smdev_header_show");
      smdev_header_btn_burger_div.classList.toggle("smdev_close_icon", isMenuOpen);
      document.body.style.overflow = isMenuOpen ? "hidden" : "";
   }

   // Close menu when clicking outside
   function closeMenuIfOpen(event) {
      const clickedElement = event.target;

      // Check if the click is on a menu item that has a submenu
      const isMenuItemWithSubmenu =
         clickedElement.tagName === 'A' &&
         clickedElement.nextElementSibling &&
         clickedElement.nextElementSibling.tagName === 'UL';

      if (isMenuItemWithSubmenu) {
         clickedElement.nextElementSibling.classList.toggle("!flex");
         event.preventDefault();
         return;
      }

      // If clicked outside the nav and menu is open, close it
      const isClickOutsideMenu = !smdev_header_nav.contains(clickedElement) &&
                                 !smdev_header_btn_burger.contains(clickedElement);

      if (isClickOutsideMenu && smdev_header_nav.classList.contains("smdev_header_show")) {
         smdev_header_nav.classList.remove("smdev_header_show");
         smdev_header_btn_burger_div.classList.remove("smdev_close_icon");
         document.body.style.overflow = "";
      }
   }

   // Event listeners
   smdev_header_btn_burger.addEventListener("click", smdev_handle_menu_mobile);
   document.addEventListener("click", closeMenuIfOpen);
   /* END ============= MENU MOBILE */
});

// ========================= /Header menu mobile =========================


// ========= embla ========= //
document.addEventListener("DOMContentLoaded", function() {
   const emblaNodes = document.querySelectorAll('.embla'); // Select all embla instances

   emblaNodes.forEach((emblaNode) => {
      let options = { loop: false };

       if(emblaNode.classList.contains('embla__parceiros')){
         options = {
            breakpoints: {
               '(min-width: 640px)': { slidesToScroll: 4 },
               '(max-width: 640px)': { slidesToScroll: 1 }
             }
         }
       }
       else if(emblaNode.classList.contains('embla__nossotrabalho')){
         options = {
            watchDrag: false
         }
       }

       const emblaApi = EmblaCarousel(emblaNode, options);

       // Handle navigation dots
       const dotsNode = emblaNode.querySelector(':scope > .embla__dots');
       if (dotsNode) {
           const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
           emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
       }

       // Handle previous/next buttons
       const prevBtnNode = emblaNode.querySelector(':scope > .embla__buttons > .embla__button--prev');
       const nextBtnNode = emblaNode.querySelector(':scope > .embla__buttons > .embla__button--next');
       if (prevBtnNode && nextBtnNode) {
           const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
               emblaApi,
               prevBtnNode,
               nextBtnNode
           );
           emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
       }
   });
});
// ========= /embla ========= //






// ========= svg icon button form ========= //
document.addEventListener("DOMContentLoaded", function () {
   const btn = document.getElementById("wpforms-submit-143");

   if (btn) {
       btn.innerHTML = `
         ENVIAR
         <svg class="shrink-0" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
         <rect width="32" height="32" rx="16" fill="#FFE2E2"/>
         <path d="M15.3474 16.6519C15.2328 16.5374 15.0961 16.4474 14.9457 16.3872L10.1883 14.4794C10.1315 14.4566 10.083 14.417 10.0494 14.3658C10.0157 14.3147 9.99853 14.2545 10.0001 14.1933C10.0017 14.1321 10.0219 14.0729 10.0581 14.0235C10.0943 13.9742 10.1448 13.9371 10.2027 13.9172L21.6013 10.0177C21.6545 9.9985 21.712 9.99483 21.7672 10.0071C21.8224 10.0194 21.8729 10.0472 21.9128 10.0872C21.9528 10.1271 21.9806 10.1776 21.9929 10.2328C22.0052 10.288 22.0015 10.3455 21.9823 10.3987L18.0828 21.7973C18.0629 21.8552 18.0258 21.9057 17.9765 21.9419C17.9271 21.9781 17.8679 21.9983 17.8067 21.9999C17.7455 22.0015 17.6853 21.9843 17.6342 21.9506C17.583 21.917 17.5434 21.8685 17.5206 21.8117L15.6128 17.0531C15.5524 16.9028 15.4621 16.7663 15.3474 16.6519ZM15.3474 16.6519L21.9109 10.0897" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
         </svg>
       `;
   }
});

// ========= /svg icon button form ========= //


// ========================= Produto: conteúdo expansível =========================
// Deixa o card de conteúdo com a mesma altura do card da imagem, para os CTAs
// caberem no viewport. CSS sozinho não resolve: não dá para limitar um elemento
// pela altura do irmão. Se o conteúdo couber, o botão nem aparece.
document.addEventListener('DOMContentLoaded', function () {
   const card = document.querySelector('[data-cf-card]');
   const area = document.querySelector('[data-cf-expansivel]');
   const btn = document.querySelector('[data-cf-toggle]');
   const colunaImg = document.querySelector('[data-cf-img]');
   if (!card || !area || !btn || !colunaImg) return;

   const rotulo = btn.querySelector('[data-cf-toggle-texto]');
   const FOLGA = 24; // px: abaixo disso não compensa recolher
   let aberto = false;

   // altura natural do card, medido sem a trava de altura
   function alturaNatural() {
      const anterior = card.style.height;
      card.style.height = 'auto';
      const natural = card.offsetHeight;
      card.style.height = anterior;
      return natural;
   }

   // No desktop a altura do card acompanha a do card da imagem.
   // No mobile isso nao serve: o card da imagem ocupa a largura toda, e depois do
   // H1, do botao e dos dois CTAs empilhados quase nao sobra altura para a
   // descricao. Por isso garantimos um minimo de descricao visivel.
   const MIN_DESCRICAO_MOBILE = 200; // px de texto a mostrar no mobile

   function ehMobile() {
      return window.matchMedia('(max-width: 769px)').matches; // md do tailwind = 770px
   }

   function alvo() {
      const imagem = colunaImg.offsetHeight;
      if (!ehMobile()) return imagem;

      // moldura = tudo no card menos a area da descricao
      const anterior = card.style.height;
      card.style.height = 'auto';
      const moldura = card.offsetHeight - area.offsetHeight;
      card.style.height = anterior;

      return Math.max(imagem, moldura + MIN_DESCRICAO_MOBILE);
   }

   // estado recolhido: trava a altura e liga o fade.
   // O navegador nao anima de 'auto' para px, entao fixamos a altura atual em px
   // antes de ir para o destino. Assim a transicao do CSS vale tambem no primeiro
   // recolhimento, que era o salto seco no carregamento.
   function recolher() {
      const destino = alvo();
      card.style.height = card.offsetHeight + 'px';
      void card.offsetHeight; // força reflow: define o ponto de partida
      card.style.height = destino + 'px';
      area.setAttribute('data-cf-fade', 'on');
      card.setAttribute('data-cf-aberto', 'false');
      card.setAttribute('data-cf-animando', 'true');
      btn.setAttribute('aria-expanded', 'false');
      rotulo.textContent = 'Ver descrição completa';
      aberto = false;
      card.addEventListener('transitionend', function fim(e) {
         if (e.propertyName !== 'height') return;
         card.removeEventListener('transitionend', fim);
         card.setAttribute('data-cf-animando', 'false');
      });
   }

   // ao recolher, devolve o viewport para o topo do produto
   function voltarAoTopo() {
      const secao = card.closest('section') || card;
      const cabecalho = document.querySelector('.smdev_header');
      const folga = (cabecalho ? cabecalho.offsetHeight : 0) + 16;
      const alvoY = secao.getBoundingClientRect().top + window.pageYOffset - folga;
      const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(alvoY, 0), behavior: suave ? 'smooth' : 'auto' });
   }

   function expandir() {
      const destino = alturaNatural();
      card.setAttribute('data-cf-aberto', 'true');
      card.setAttribute('data-cf-animando', 'true');
      area.setAttribute('data-cf-fade', 'off');
      btn.setAttribute('aria-expanded', 'true');
      rotulo.textContent = 'Ver menos';
      aberto = true;
      card.style.height = destino + 'px';
      // ao fim da animação solta a altura, senão imagem que carregue depois corta
      card.addEventListener('transitionend', function solta(e) {
         if (e.propertyName !== 'height') return;
         card.removeEventListener('transitionend', solta);
         card.setAttribute('data-cf-animando', 'false');
         if (aberto) card.style.height = 'auto';
      });
   }

   // decide se o botão é necessário
   function sincronizar() {
      if (aberto) return;
      card.style.height = 'auto';
      const precisa = alturaNatural() > alvo() + FOLGA;
      btn.hidden = !precisa;
      if (precisa) {
         recolher();
      } else {
         card.style.height = '';
         area.setAttribute('data-cf-fade', 'off');
      }
   }

   btn.addEventListener('click', function () {
      if (aberto) {
         recolher();
         voltarAoTopo();
      } else {
         expandir();
      }
   });

   sincronizar();

   // a imagem muda a altura da coluna ao carregar, e o resize muda tudo
   if ('ResizeObserver' in window) {
      let ticking = false;
      const ro = new ResizeObserver(function () {
         if (ticking) return;
         ticking = true;
         requestAnimationFrame(function () {
            ticking = false;
            sincronizar();
         });
      });
      ro.observe(colunaImg);
   } else {
      window.addEventListener('resize', sincronizar);
   }
});

// ========================= Galeria do produto =========================
// Dois carrosséis Embla: o palco (imagem grande) e a faixa de miniaturas.
// A miniatura clicada troca a imagem grande, e arrastar a imagem grande move a
// faixa junto. Sem setas e sem bolinhas: o que indica que há mais miniaturas é
// um degradê lateral, ligado por data-attribute só do lado que ainda rola.
// Classe própria (.cf_galeria) para o init genérico de .embla não pegar este nó.
document.addEventListener('DOMContentLoaded', function () {
   const galeria = document.querySelector('[data-cf-galeria]');
   if (!galeria) return;

   const viewport = galeria.querySelector('[data-cf-viewport]');
   const faixa = galeria.querySelector('[data-cf-thumbs]');
   const faixaWrap = galeria.querySelector('[data-cf-thumbs-wrap]');
   const thumbs = Array.prototype.slice.call(galeria.querySelectorAll('[data-cf-thumb]'));
   if (!viewport || !thumbs.length) return;

   const palco = EmblaCarousel(viewport, { loop: false });

   const tira = faixa
      ? EmblaCarousel(faixa, {
           loop: false,
           dragFree: true,
           containScroll: 'keepSnaps',
           align: 'start'
        })
      : null;

   function marcarAtivo() {
      const atual = palco.selectedScrollSnap();
      thumbs.forEach(function (t, i) {
         const ativo = i === atual;
         t.classList.toggle('is-ativo', ativo);
         t.setAttribute('aria-pressed', ativo ? 'true' : 'false');
      });
      // mantém a miniatura selecionada dentro da área visível da faixa
      if (tira) tira.scrollTo(atual);
   }

   // liga o degradê só do lado em que ainda há miniatura escondida.
   // Se tudo couber na largura, nenhum dos dois aparece.
   function atualizarDegrade() {
      if (!tira || !faixaWrap) return;
      faixaWrap.setAttribute('data-cf-antes', tira.canScrollPrev() ? 'true' : 'false');
      faixaWrap.setAttribute('data-cf-depois', tira.canScrollNext() ? 'true' : 'false');
   }

   thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { palco.scrollTo(i); });
   });

   palco.on('select', marcarAtivo);
   palco.on('reInit', marcarAtivo);

   if (tira) {
      tira.on('select', atualizarDegrade);
      tira.on('scroll', atualizarDegrade);
      tira.on('settle', atualizarDegrade);
      tira.on('reInit', atualizarDegrade);
      tira.on('resize', atualizarDegrade);
   }

   marcarAtivo();
   atualizarDegrade();
});

// ========================= Galeria: vídeo sob demanda =========================
// A capa do vídeo é só uma imagem. O iframe do YouTube (cerca de 1MB de script)
// só entra na página quando a pessoa clica, para não penalizar o carregamento
// de todas as páginas de produto por causa de um vídeo que a maioria não assiste.
document.addEventListener('DOMContentLoaded', function () {
   document.querySelectorAll('[data-cf-video]').forEach(function (botao) {
      botao.addEventListener('click', function () {
         const id = botao.getAttribute('data-cf-video');
         if (!id) return;

         const frame = document.createElement('iframe');
         frame.className = 'cf_video__frame';
         // nocookie: não grava cookie de rastreio de quem só abriu a página
         frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                     '?autoplay=1&rel=0';
         frame.title = botao.getAttribute('aria-label') || 'Vídeo do produto';
         frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; ' +
                       'gyroscope; picture-in-picture; web-share';
         frame.referrerPolicy = 'strict-origin-when-cross-origin';
         frame.allowFullscreen = true;

         botao.replaceWith(frame);
      });
   });
});

// ========================= Busca rápida (Cmd+K) =========================
// O catálogo inteiro tem ~3,3 KB gzipado, então o índice vem de uma vez e a
// filtragem acontece no navegador: zero requisição por tecla.
// Travas: índice só baixa ao abrir a busca pela primeira vez, fica em
// sessionStorage, mínimo de 2 letras, debounce de 120ms e teto de 8 resultados.
document.addEventListener('DOMContentLoaded', function () {
   const raiz = document.querySelector('[data-cf-busca]');
   if (!raiz) return;

   const campo = raiz.querySelector('[data-cf-busca-campo]');
   const lista = raiz.querySelector('[data-cf-busca-lista]');
   const aviso = raiz.querySelector('[data-cf-busca-aviso]');
   const gatilhos = document.querySelectorAll('[data-cf-busca-abrir]');
   const fechadores = raiz.querySelectorAll('[data-cf-busca-fechar]');

   const ENDPOINT = raiz.getAttribute('data-endpoint');
   const HOME = raiz.getAttribute('data-home') || '';
   const SEM_FOTO = raiz.getAttribute('data-placeholder') || '';
   // a chave carrega a versão do índice: quando um produto ou categoria muda,
   // a versão muda e o índice guardado na sessão deixa de ser usado
   const CHAVE = 'cf_busca_indice_' + (raiz.getAttribute('data-versao') || '0');
   const MIN = 2;
   const TETO = 8;

   // O símbolo ⌘ só faz sentido no Mac. No Windows e no Linux vira "Ctrl K".
   // Fica escondido até aqui para não piscar o símbolo errado.
   const ehMac = /mac|iphone|ipad|ipod/i.test(
      (navigator.userAgentData && navigator.userAgentData.platform) ||
      navigator.platform || navigator.userAgent || ''
   );
   document.querySelectorAll('[data-cf-atalho]').forEach(function (k) {
      k.textContent = ehMac ? '\u2318 K' : 'Ctrl K';
      k.hidden = false;
   });

   let indice = null;
   let carregando = null;
   let resultados = [];
   let ativo = -1;
   let voltarFoco = null;
   let timer = null;

   function semAcento(s) {
      return (s || '')
         .normalize('NFD').replace(/[̀-ͯ]/g, '')
         .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
   }

   // trava: uma requisição por sessão, e só quando a busca é aberta
   function carregarIndice() {
      if (indice) return Promise.resolve(indice);
      if (carregando) return carregando;

      try {
         const salvo = sessionStorage.getItem(CHAVE);
         if (salvo) {
            indice = JSON.parse(salvo);
            return Promise.resolve(indice);
         }
         // limpa índices de versões antigas para não entulhar a sessão
         for (let i = sessionStorage.length - 1; i >= 0; i--) {
            const k = sessionStorage.key(i);
            if (k && k.indexOf('cf_busca_indice_') === 0 && k !== CHAVE) {
               sessionStorage.removeItem(k);
            }
         }
      } catch (e) { /* sessionStorage bloqueado: segue pela rede */ }

      carregando = fetch(ENDPOINT, { credentials: 'same-origin' })
         .then(function (r) { return r.ok ? r.json() : []; })
         .then(function (dados) {
            indice = Array.isArray(dados) ? dados : [];
            try { sessionStorage.setItem(CHAVE, JSON.stringify(indice)); } catch (e) {}
            return indice;
         })
         .catch(function () { indice = []; return indice; })
         .finally(function () { carregando = null; });

      return carregando;
   }

   function pontuar(item, termos, cru) {
      const codigo = semAcento(item.c);
      if (codigo && codigo === cru) return 0;                  // código exato primeiro
      if (codigo && codigo.indexOf(cru) === 0) return 1;
      if (item.n.indexOf(cru) === 0) return 2;                 // título começa com o termo
      const todas = termos.every(function (t) { return item.n.indexOf(t) !== -1; });
      return todas ? 3 : -1;
   }

   function buscar(texto) {
      const cru = semAcento(texto);
      if (cru.length < MIN || !indice) return [];
      const termos = cru.split(' ').filter(Boolean);
      const achados = [];
      for (let i = 0; i < indice.length; i++) {
         const p = pontuar(indice[i], termos, cru);
         if (p >= 0) achados.push({ item: indice[i], p: p, i: i });
      }
      achados.sort(function (a, b) { return a.p - b.p || a.i - b.i; });
      return achados.slice(0, TETO).map(function (x) { return x.item; });
   }

   function desenhar() {
      lista.innerHTML = resultados.map(function (it, n) {
         const img = it.i ? HOME + it.i : SEM_FOTO;
         const meta = [it.c ? 'Código ' + it.c : '', it.g].filter(Boolean).join(' · ');
         return '<li class="cf_busca__item' + (n === ativo ? ' is-ativo' : '') + '" role="option"' +
                ' aria-selected="' + (n === ativo ? 'true' : 'false') + '">' +
                '<a href="' + HOME + it.u + '">' +
                '<img src="' + img + '" alt="" loading="lazy" decoding="async">' +
                '<span><span class="cf_busca__titulo">' + it.t + '</span>' +
                (meta ? '<span class="cf_busca__meta">' + meta + '</span>' : '') +
                '</span></a></li>';
      }).join('');
      campo.setAttribute('aria-expanded', resultados.length ? 'true' : 'false');
   }

   function mostrarAviso(texto) {
      aviso.textContent = texto;
      aviso.hidden = !texto;
   }

   function filtrar() {
      const texto = campo.value.trim();
      ativo = -1;

      if (texto.length < MIN) {
         resultados = [];
         lista.innerHTML = '';
         campo.setAttribute('aria-expanded', 'false');
         mostrarAviso('Digite ao menos ' + MIN + ' letras.');
         return;
      }

      carregarIndice().then(function () {
         resultados = buscar(texto);
         desenhar();
         mostrarAviso(resultados.length ? '' : 'Nenhum produto encontrado para "' + texto + '".');
      });
   }

   function abrir() {
      voltarFoco = document.activeElement;
      raiz.hidden = false;
      document.body.style.overflow = 'hidden';
      carregarIndice();                 // adianta o download enquanto a pessoa digita
      campo.value = '';
      filtrar();
      campo.focus();
   }

   function fechar() {
      raiz.hidden = true;
      document.body.style.overflow = '';
      if (voltarFoco && voltarFoco.focus) voltarFoco.focus();
   }

   function mover(passo) {
      if (!resultados.length) return;
      ativo = (ativo + passo + resultados.length) % resultados.length;
      desenhar();
      const alvo = lista.children[ativo];
      if (alvo) alvo.scrollIntoView({ block: 'nearest' });
   }

   gatilhos.forEach(function (g) { g.addEventListener('click', abrir); });
   fechadores.forEach(function (f) { f.addEventListener('click', fechar); });

   // trava: espera a digitação parar antes de redesenhar a lista
   campo.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(filtrar, 120);
   });

   campo.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); mover(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mover(-1); }
      else if (e.key === 'Enter' && ativo >= 0) {
         const link = lista.children[ativo] && lista.children[ativo].querySelector('a');
         if (link) { e.preventDefault(); window.location.href = link.href; }
      }
   });

   document.addEventListener('keydown', function (e) {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
         e.preventDefault();
         raiz.hidden ? abrir() : fechar();
      } else if (e.key === 'Escape' && !raiz.hidden) {
         fechar();
      }
   });
});

// ========================= Vídeos: link compartilhável =========================
// Cada card tem id próprio. O link fica /videos/?v=slug#v-slug: a âncora leva a
// pessoa ao card certo e o ?v= faz o PHP emitir o preview daquele vídeo no
// WhatsApp. Não é página nova, então não disputa busca com a página do produto.
document.addEventListener('DOMContentLoaded', function () {
   const cards = document.querySelectorAll('[data-cf-slug]');
   if (!cards.length) return;

   // botão copiar link
   document.querySelectorAll('[data-cf-share]').forEach(function (botao) {
      const rotulo = botao.querySelector('[data-cf-share-texto]');
      const original = rotulo ? rotulo.textContent : '';

      botao.addEventListener('click', function () {
         const url = botao.getAttribute('data-cf-share');

         function avisar(ok) {
            if (!rotulo) return;
            rotulo.textContent = ok ? 'Link copiado' : 'Copie da barra';
            botao.classList.toggle('is-copiado', ok);
            setTimeout(function () {
               rotulo.textContent = original;
               botao.classList.remove('is-copiado');
            }, 2000);
         }

         if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(function () { avisar(true); },
                                                    function () { avisar(false); });
         } else {
            // http local e navegador antigo não têm clipboard: cai no método velho
            const campo = document.createElement('textarea');
            campo.value = url;
            campo.setAttribute('readonly', '');
            campo.style.position = 'fixed';
            campo.style.opacity = '0';
            document.body.appendChild(campo);
            campo.select();
            let ok = false;
            try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
            document.body.removeChild(campo);
            avisar(ok);
         }
      });
   });

   // chegou por link compartilhado: leva até o card e abre o player
   const params = new URLSearchParams(window.location.search);
   const slug = params.get('v') ||
                (window.location.hash ? window.location.hash.replace(/^#v-/, '') : '');
   if (!slug) return;

   const alvo = document.querySelector('[data-cf-slug="' + CSS.escape(slug) + '"]');
   if (!alvo) return;

   const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   alvo.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'center' });
   alvo.classList.add('is-alvo');
   setTimeout(function () { alvo.classList.remove('is-alvo'); }, 8000);

   const play = alvo.querySelector('[data-cf-video]');
   if (play) play.click();
});
